import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { getDataRetentionApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';

import downloadCsv from 'download-csv';
export default {
  name: 'DataRetention',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      small: true,
      retentionData: [],
      tableField: [{
        key: 'date',
        label: '月份'
      }, {
        key: 'retCounts',
        label: '資料筆數'
      }, {
        key: 'retPct',
        label: '資料妥善率 (%)'
      }],
      dataClassArr: ['資料筆數', '資料妥善率'],
      dataClass: ['資料筆數', '資料妥善率'],
      retentionChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '資料筆數'
          }
        }, {
          title: {
            text: '資料妥善率 (%)'
          },
          opposite: true,
          max: 100,
          min: 0
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(80, 157, 179)',
          type: 'column',
          name: '資料筆數',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(255, 192, 0)',
          type: 'line',
          name: '資料妥善率 (%)',
          data: [],
          yAxis: 1,
          visible: true
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      retentionDataForExcel: []
    };
  },
  methods: {
    getRetention: function getRetention(months) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _retentionData$data, retentionData, concatData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.retentionChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context.prev = 1;
                _context.next = 4;
                return getDataRetentionApi(_this.$route.query.fid, months);
              case 4:
                retentionData = _context.sent;
                if (retentionData !== null && retentionData !== void 0 && (_retentionData$data = retentionData.data) !== null && _retentionData$data !== void 0 && _retentionData$data.success) {
                  // 複製 retentionData、etodayDataForExcel 不能 refer 同個 data
                  // renderData() 會改動 retentionData 資料
                  concatData = retentionData.data.data.reduce(function (acc, cur) {
                    return acc.concat(cur);
                  }, []); // 下載資料用
                  _this.retentionDataForExcel = concatData;

                  // 顯示圖表、表格用，copy 避免改動到 rawData (retentionData.data.data)
                  _this.retentionData = concatData.map(function (item) {
                    var copy = Object.assign({}, item);
                    return copy;
                  });
                  _this.renderData();
                  _this.hasNoData = false;
                }
                _context.next = 13;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getRetention error: ', _context.t0);
                _this.hasNoData = true;
                _context.t0.msg && _this.$swal(_context.t0.msg);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    renderData: function renderData() {
      var _this2 = this;
      this.retentionChart.xAxis.categories = [];
      this.retentionChart.series.forEach(function (x) {
        x.data = [];
      });
      this.retentionData.forEach(function (x) {
        _this2.retentionChart.xAxis.categories.push(x.date);
        // 圖表、表格 是共用 this.retentionData 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.retCounts = x.retCounts === null ? null : dbDataHandle(x.retCounts);
        x.retPct = x.retPct === null ? null : dbDataHandle(x.retPct * 100);
        _this2.retentionChart.series[0].data.push(x.retCounts);
        _this2.retentionChart.series[1].data.push(x.retPct);
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.retentionChart.chart.events = {};
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.retentionChart.xAxis.categories);
      this.retentionChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.retentionChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.retentionDataForExcel.forEach(function (obj) {
        var retCounts = obj.retCounts === null ? null : obj.retCounts;
        var retPct = obj.retPct === null ? null : obj.retPct * 100;
        download[0].data.push(retCounts);
        download[1].data.push(retPct);
      });
      this.retentionChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    }
  },
  mounted: function mounted() {},
  watch: {
    dataClassArr: function dataClassArr(newValue, oldValue) {
      var _this3 = this;
      var setData = [{
        name: '資料筆數',
        dataName: ['資料筆數']
      }, {
        name: '資料妥善率',
        dataName: ['資料妥善率 (%)']
      }];
      if (oldValue !== newValue) {
        this.retentionChart.series.forEach(function (x) {
          x.visible = false;
        });
        setData.forEach(function (x) {
          if (newValue.includes(x.name)) {
            x.dataName.forEach(function (y) {
              _this3.retentionChart.series.find(function (z) {
                return z.name === y;
              }).visible = true;
            });
          }
        });
      }
    }
  }
};